import { COMMUNICATION_STATUSES } from "./CustomerCommunication";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";

export type AITemplateID = number;

export type GenAIUsageID = number;

export interface AITemplate {
  created_on: string;
  updated_on: string;
  id: AITemplateID; // Claire AI Template ID
  template: string; // Claire AI Template
  system_prompt: string; // System prompt for GENAI
  communication_status: COMMUNICATION_STATUSES; // Communication Status with which this template is associated
}

export interface GenAIUsage {
  created_on: string;
  id: GenAIUsageID; // Gen AI Usage ID
  dealer_location_id: DealerLocationID; // Claire Dealer Location ID
  dealer_id: DealerID; // Claire Dealer ID
  purpose: string; // Purpose of the Gen AI Usage
  model: string; // Model used for the Gen AI Usage
  candidates_token_count: number; // Number of candidates token count
  prompts_token_count: number; // Number of prompts token count
  thoughts_token_count: number; // Number of thoughts token count
  tool_use_prompt_token_count: number; // Number of tool use prompt token count
  total_token_count: number; // Total number of token count
  input_million_token_price: number; // Input million token price
  output_million_token_price: number; // Output million token price
}
